/* ═══════════════════════════════════════════
   NEW CLEAN — SHOPIFY THEME JS
   ═══════════════════════════════════════════ */

// ── CART ──────────────────────────────────

async function ncAddToCart(btn) {
  const variantId = btn.dataset.variantId;
  const title     = btn.dataset.productTitle || 'Produto';

  btn.disabled = true;
  btn.textContent = '...';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (!res.ok) throw new Error('Erro ao adicionar');

    await ncRefreshCart();
    ncShowToast('✓ ' + title.slice(0, 30) + ' adicionado!');
    btn.classList.add('added');
    btn.textContent = '✓ Adicionado';
    setTimeout(() => {
      btn.classList.remove('added');
      btn.textContent = '+ Adicionar ao carrinho';
      btn.disabled = false;
    }, 2000);

    ncOpenCart();
  } catch (e) {
    ncShowToast('❌ Erro ao adicionar ao carrinho');
    btn.disabled = false;
    btn.textContent = '+ Adicionar ao carrinho';
  }
}

async function ncRefreshCart() {
  const res  = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
  const cart = await res.json();
  ncRenderCart(cart);
}

function ncRenderCart(cart) {
  // Count badge
  const countEl = document.getElementById('cartCount');
  if (countEl) countEl.textContent = cart.item_count;

  const itemsEl = document.getElementById('cartItems');
  const footEl  = document.getElementById('cartFoot');
  const totalEl = document.getElementById('cartTotal');
  const subEl   = document.getElementById('cartSubtotal');

  if (!itemsEl) return;

  if (cart.item_count === 0) {
    itemsEl.innerHTML = '<div class="cart-empty"><span>🛒</span>Seu carrinho está vazio</div>';
    if (footEl) footEl.style.display = 'none';
    return;
  }

  const fmt = (cents) => (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  itemsEl.innerHTML = cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <div class="cart-item-img">
        ${item.image
          ? `<img src="${item.image}" alt="${item.title}" />`
          : '<span style="font-size:1.8rem">🧴</span>'
        }
      </div>
      <div class="cart-item-info">
        <div class="cart-item-name">${item.product_title}</div>
        <div class="cart-item-price">${fmt(item.line_price)}</div>
        <div class="qty-ctrl">
          <button class="qty-btn" onclick="ncChangeQty('${item.key}', ${item.quantity - 1})">−</button>
          <span class="qty-num">${item.quantity}</span>
          <button class="qty-btn" onclick="ncChangeQty('${item.key}', ${item.quantity + 1})">+</button>
        </div>
      </div>
      <button class="btn-remove" onclick="ncChangeQty('${item.key}', 0)" aria-label="Remover">🗑</button>
    </div>
  `).join('');

  if (footEl)  footEl.style.display = 'flex';
  if (totalEl) totalEl.textContent = fmt(cart.total_price);
  if (subEl)   subEl.textContent   = fmt(cart.total_price);
}

async function ncChangeQty(key, qty) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  });
  await ncRefreshCart();
}

function ncOpenCart() {
  document.getElementById('cartOverlay')?.classList.add('open');
  document.getElementById('cartPanel')?.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function ncCloseCart() {
  document.getElementById('cartOverlay')?.classList.remove('open');
  document.getElementById('cartPanel')?.classList.remove('open');
  document.body.style.overflow = '';
}

function ncCheckout() {
  window.location.href = '/checkout';
}

// ── TOAST ─────────────────────────────────

function ncShowToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(t._timer);
  t._timer = setTimeout(() => t.classList.remove('show'), 2800);
}

// ── MOBILE MENU ───────────────────────────

document.getElementById('menuToggle')?.addEventListener('click', () => {
  document.getElementById('mobileNav')?.classList.toggle('open');
});

// ── CART BUTTON ───────────────────────────

document.getElementById('cartBtn')?.addEventListener('click', ncOpenCart);

// ── INIT: load cart on page load ──────────

document.addEventListener('DOMContentLoaded', ncRefreshCart);
